import { PrivacyLaw } from '../types';

export const piaLaws: PrivacyLaw[] = [
  {
    id: 'va',
    name: 'Virginia CDPA',
    category: 'usState',
    description: 'Required for processing sensitive data or selling personal data under VCDPA § 59.1-576'
  },
  {
    id: 'ca',
    name: 'California CPRA',
    category: 'usState',
    description: 'Required for high-risk processing activities under CPRA regulations'
  },
  {
    id: 'ct',
    name: 'Connecticut CTDPA',
    category: 'usState',
    description: 'Required under Connecticut Data Privacy Act for processing sensitive data'
  },
  {
    id: 'co',
    name: 'Colorado CPA',
    category: 'usState',
    description: 'Required for processing sensitive data or profiling under CPA § 6-1-1309'
  },
  {
    id: 'mt',
    name: 'Montana Consumer Data Privacy Act',
    category: 'usState',
    description: 'Required for processing sensitive data under Montana SB 384'
  },
  {
    id: 'tn',
    name: 'Tennessee Information Privacy Act',
    category: 'usState',
    description: 'Required for certain data processing activities under TIPA'
  },
  {
    id: 'in',
    name: 'Indiana Consumer Data Protection Act',
    category: 'usState',
    description: 'Required for processing sensitive data under Indiana Code § 24-15'
  },
  {
    id: 'tx',
    name: 'Texas Data Privacy and Security Act',
    category: 'usState',
    description: 'Required for processing sensitive personal data under Texas HB 4'
  },
  {
    id: 'fl',
    name: 'Florida Digital Bill of Rights',
    category: 'usState',
    description: 'Required for processing sensitive data under Florida HB 969'
  },
  {
    id: 'or',
    name: 'Oregon Consumer Privacy Act',
    category: 'usState',
    description: 'Required for processing sensitive personal data under Oregon SB 619'
  },
  {
    id: 'de',
    name: 'Delaware Personal Data Privacy Act',
    category: 'usState',
    description: 'Required for processing sensitive data under Delaware Code Title 6 Chapter 12C'
  }
];